module.exports = __webpack_public_path__ + "media/application/images/ui/icon-menu-hamburger-4afcf47b5c946d5a9058cd20495400c9.png";